<template>
  <div>
    <InterestShowFields
      v-if="interestFieldOptions && interestFieldOptions.length"
      ref="InterestShowFields"
      v-model="isShowFieldPopup"
      :interest-field-options="interestFieldOptions"
      :form-data="formData"
      :backup-add-and-take-data="backupAddAndTakeData"
      :params="{
        uuid: params.uuid,
        insuredAge: params.insuredAge
      }"
      :interest-detail-request-params="interestDetailRequestParams"
      @confirm="data => $emit('update', data)"
    />

    <CommonPopup
      v-model="popupConfig.visible"
      :title="popupConfig.title"
      round
      closeable
      position="bottom"
      get-container="body"
      :show-footer="false"
      :z-index="105"
      @close="close"
    >
      <AddAndTake
        v-if="popupConfig.visible"
        ref="AddAndTake"
        :type="popupConfig.type"
        :scene="popupConfig.scene"
        :input-data="popupConfig.inputData"
        :result-uuid="popupConfig.resultUuid"
        :group-key="popupConfig.groupKey"
        :product-key="popupConfig.productKey"
        :insurance-key="popupConfig.insuranceKey"
        :insured-age="popupConfig.insuredAge"
        :period-num="popupConfig.periodNum"
        :account-data="popupConfig.accountData"
        :account-insurance-id="popupConfig.accountInsuranceId"
        :reduce-baof-data="popupConfig.reduceBaofData"
        :reduce-baof-data2="popupConfig.reduceBaofData2"
        :reduce-baof-insurance-id="popupConfig.reduceBaofInsuranceId"
        :interest-data="popupConfig.interestData"
        @confirm="confirmAddAndTake"
      />
    </CommonPopup>
    <SingleValueAlgorithmPopup
      v-model="isShowSingleValueAlgoPopup"
      :form-values="formData.formValues"
      :options="singleValueAlgorithmOptions"
      @confirm="data => $emit('update', data)"
    />
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import { AddAndTake } from 'bxs-tools-ui'
import CommonPopup from '@/components/common/common-popup/index.vue'
import InterestShowFields from './interest-show-fields.vue'
import SingleValueAlgorithmPopup from './single-algorithm-popup.vue'

function initPopupConfig() {
  return {
    title: '',
    type: '',
    scene: null,
    groupKey: null,
    productKey: null,
    insuranceKey: null,
    resultUuid: null,
    inputData: null,
    insuredAge: null,
    periodNum: null,
    accountData: null,
    accountInsuranceId: null,
    reduceBaofData: null,
    reduceBaofData2: null,
    reduceBaofInsuranceId: null,
    interestData: null
  }
}
const titleMap = {
  addAndTake: '追加领取',
  add: '追加保费',
  take: '部分领取',
  reduceBaof: '减保领取'
}

export default {
  components: {
    AddAndTake,
    CommonPopup,
    InterestShowFields,
    SingleValueAlgorithmPopup
  },
  props: {
    resultData: {
      type: Object,
      required: true
    },
    interestFieldOptions: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
    interestDetailRequestParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      backupAddAndTakeData: null,
      popupConfig: initPopupConfig(),
      isShowSingleValueAlgoPopup: false
    }
  },
  computed: {
    isShowFieldPopup () {
      return this.formData.formValues.isShowFieldPopup
    },
    singleValueAlgorithmOptions () {
      const item = (this.interestFieldOptions || []).find(o => o.key === 'singleCalType')
      return item ? item.options : []
    }
  },
  watch: {
    isShowFieldPopup (v) {
      this.backupAddAndTakeData = v ? cloneDeep({
        drawData: this.formData.drawData,
        duplicateDrawData: this.formData.duplicateDrawData,
        addAndTakeData: this.formData.accountData
      }) : null
    }
  },
  methods: {
    // @external 该方法被外部直接调用
    openAddAndTakePicker (item) {
      const { resultData, formData, params } = this
      const { personData, productGroupList } = resultData
      const { productId, drawData, duplicateDrawData, drawInsuranceId, addAndTakeData, accountInsuranceId, formValues, customRate } = formData
      const isReduceBaof = item.key === 'drawData'
      const type = isReduceBaof ? 'reduceBaof' : addAndTakeData.accountPart
      
      const bonus = _get(formValues, 'bonus') === 'PSUDO_OPTION_CUSTOM_RATE' ? 'mid' : _get(formValues, 'bonus') || null
      const bonusCustomRate = _get(formValues, 'bonusCustomRate')
      const bonusRealRate = bonusCustomRate && _get(formValues, 'bonus') === 'PSUDO_OPTION_CUSTOM_RATE' ? parseFloat((bonusCustomRate / 100).toFixed(2)) : null
      const popupConfig = {
        visible: true,
        title: titleMap[type],
        type,
        scene: 1,
        inputData: {
          personData,
          productGroupList,
        },
        resultUuid: params.uuid,
        groupKey: _get(productGroupList, '[0].key'),
        productKey: productId,
        insuranceKey: isReduceBaof ? drawInsuranceId : accountInsuranceId,
        insuredAge: _get(personData, 'personOrderList[0].age'),
        periodNum: null,
        accountData: addAndTakeData,
        accountInsuranceId: accountInsuranceId,
        reduceBaofData: {
          accountPart: 'take',
          addAndTakeData: drawData || []
        },
        reduceBaofData2: {
          accountPart: 'take',
          addAndTakeData: duplicateDrawData || []
        },
        reduceBaofInsuranceId: drawInsuranceId,
        interestData: {
          bonus,
          bonusRealRate,
          takeType: formValues.takeType,
          bonusTake: formValues.bonusTake,
          pensionTake: formValues.pensionTake,
          rate: formValues.rateIndex === -1 ? customRate : formValues.rate,
        },
      }
      productGroupList.forEach(g => {
        (g.prodOrderList || []).forEach(p => {
          (p.mulInsOrderList || []).forEach(ins => {
            if (ins.key === popupConfig.insuranceKey) {
              popupConfig.periodNum = ins.periodNum
            }
          })
        })
      })
      this.popupConfig = popupConfig
    },
    confirmAddAndTake(data) {
      const { popupConfig, formData, interestFieldOptions } = this
      const { productId, formValues } = formData
      const { type, accountData, accountInsuranceId, reduceBaofData, reduceBaofData2, interestData } = data
      const { bonus, customRate, endBonusRate, rate, takeType, bonusTake, pensionTake, yearBonusRate } = interestData

      let _oBonus = bonus
      // 临时方案：目前减保领取不支持切换分红，bonusRealRate 默认是为1。为非 1 时，可以认为是自定义红利实现率
      const _oBonusRealRate = _get(popupConfig, 'interestData.bonusRealRate')
      if (_oBonusRealRate && _oBonusRealRate !== 1) {
        _oBonus = _get(formData, 'formValues.bonus')
      }

      const _isReduceBaof = type === 'reduceBaof'
      const _rateField = interestFieldOptions.find(e => e.key === 'rate')
      const _rateOptionIndex = _get(_rateField, 'options', []).findIndex(o => o.value === rate)
      const _rateIndex = _rateOptionIndex > -1 ? _rateOptionIndex : 3
      const _updateData = {
        drawData: _get(reduceBaofData, 'addAndTakeData'),
        duplicateDrawData: _get(reduceBaofData2, 'addAndTakeData'),
        addAndTakeData: accountData,
        rateIndex: _rateIndex,
        drawFlag: (_get(reduceBaofData, 'addAndTakeData') || []).some(e => e.adjustData && e.adjustData.length) || (_get(reduceBaofData2, 'addAndTakeData') || []).some(e => e.adjustData && e.adjustData.length),
        addAndTakeFlag: (_get(accountData, 'addAndTakeData') || []).some(e => e.adjustData && e.adjustData.length),
        displayFields: formValues.displayFields,
        bonus: _oBonus,
        customRate,
        endBonusRate,
        rate,
        takeType,
        bonusTake,
        pensionTake,
        yearBonusRate,
      }
      // 暂不更新数据，当 InterestShowFields 组件的确定按钮点击时再更新
      if (!_isReduceBaof) {
        this.$emit('update-account-map', {
          productId,
          accountInsuranceId,
          addAndTakeData: accountData.addAndTakeData,
        })
      }
      this.$emit('update', _updateData)
      this.popupConfig = initPopupConfig()
    },
    close() {
      const { $refs, popupConfig } = this
      if (!popupConfig.visible) {
        const refAddAndTake = $refs.AddAndTake
        if (refAddAndTake && refAddAndTake.subName === 'Form') {
          refAddAndTake.goToTable()
          this.popupConfig.visible = true
        } 
      }
    }
  }
}
</script>